import type {
  CrudFormItem,
  CrudSearchItem,
  CrudTableColumn
} from '@/types/crud-config'
import type { CertificateRecord } from './certificate.service'

export interface CertificateForm {
  name: string
  ip: string
  certificate: string
  endTime: string | null | undefined
  aliAccount: string
}

export const certificateSearchItems: CrudSearchItem[] = [
  {
    label: '项目名称',
    prop: 'name',
    type: 'input',
    controlClass: 'certificate-page__search-control',
    clearable: true,
    placeholder: '请输入项目名称'
  }
]

export const certificateFormItems: CrudFormItem<CertificateForm>[] = [
  {
    label: '项目名称',
    prop: 'name',
    type: 'input',
    clearable: true,
    placeholder: '请输入项目名称'
  },
  {
    label: '服务器IP',
    prop: 'ip',
    type: 'input',
    clearable: true,
    placeholder: '请输入服务器IP'
  },
  {
    label: '证书名称',
    prop: 'certificate',
    type: 'input',
    clearable: true,
    placeholder: '请输入证书名称'
  },
  {
    label: '到期时间',
    prop: 'endTime',
    type: 'date',
    valueFormat: 'YYYY-MM-DD',
    placeholder: '选择到期时间'
  },
  {
    label: '阿里云账号',
    prop: 'aliAccount',
    type: 'input',
    clearable: true,
    placeholder: '请输入阿里云账号'
  }
]

export function createCertificateTableColumns(
  showActions: boolean
): CrudTableColumn<CertificateRecord>[] {
  const columns: CrudTableColumn<CertificateRecord>[] = [
    {
      prop: 'name',
      label: '项目名称',
      minWidth: 140,
      showOverflowTooltip: true
    },
    {
      prop: 'ip',
      label: '服务器IP',
      minWidth: 130,
      showOverflowTooltip: true
    },
    {
      prop: 'certificate',
      label: '证书名称',
      minWidth: 150,
      showOverflowTooltip: true
    },
    {
      prop: 'endTime',
      label: '到期时间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'aliAccount',
      label: '阿里云账号',
      minWidth: 140,
      showOverflowTooltip: true
    }
  ]

  if (showActions) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      width: 180,
      fixed: 'right'
    })
  }

  return columns
}
